document.addEventListener("DOMContentLoaded", function () {
  
  
  $('.fml-rating').starRating({
    starSize: 25,
    totalStars: 5,
    emptyColor: 'lightgray',
    hoverColor: 'salmon',
    activeColor: 'cornflowerblue',
    initialRating: localStorage.getItem("present_rating"),
    disableAfterRate: false,
    useFullStars: true,
    strokeWidth: 0,
    useGradient: false,
    callback: function (vote, $el) {
      let rating_string = $('#single-star-evaluation').val();
      if (vote > 1) {
        rating_string = $('#multiple-star-evaluation').val();
      }
      if (confirm(rating_string.replace(new RegExp('%vote', "g"), vote))) {
        $('.fml-rating').starRating('setReadOnly', true);
        $.post(
          "/api/v1/feedback",
          {
            feedback: {
              vote: vote,
              user_id: localStorage.getItem("current_user_id"),
              give_back_request_id: localStorage.getItem("give_back_request_id")
            }
          },
          function (data) {
            $('#fml-rating-text').text(localStorage.getItem("feedback_thank_you"));
          }
        )
      } else {
        $('.fml-rating').starRating('setReadOnly', false);
        $('.fml-rating').starRating('setRating', 0);
      }
    }
  });
});
